module.exports = __webpack_public_path__ + "img/zhangdan.14021ffa.svg";